module.exports = __webpack_public_path__ + "img/product_47.4c840c3.svg";